import { ShowPerPage } from "@/stores/showPerPage/showPerPage"
import { HttpRequestAxios } from "../../axios"
interface ListType {
    page?: any
    order: string
    search?: any
    showPerPage: number
}
interface GetUser {
    userID: number
}
interface GetRemove{
    userID:number
}
export async function GET_USER_LIST(page = 1, search?: any) {
    let data: ListType = {
        order: 'asc',
        page: page,
        search: search,
        showPerPage: ShowPerPage
    }

    return await HttpRequestAxios({ url: '/user/list', data: data })
}

export async function POST_ADD_USER(data: any) {


    return await HttpRequestAxios({ url: '/user/add', data: data })
}
export async function GET_USER_DATA(UserID: any) {
    let data: GetUser = {
        userID: UserID
    }
    return await HttpRequestAxios({ url: '/user/get', data: data })
}
export async function POST_UPLOAD_EDIT_CONTACT(data:any) {

    return await HttpRequestAxios({ url: '/upload' ,data:data})
}
export async function POST_EDIT_DATA_CONTACT(data:any) {

    return await HttpRequestAxios({ url: '/user/update' ,data:data})
}

export async function POST_REMOVE_USER(userID:any) {
let data:GetRemove = {
    userID :userID
}
    return await HttpRequestAxios({ url: '/user/remove' ,data:data})
}
